import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import reducers from 'reducers';

import { watchSagas } from 'sagas';

const resetEnhancer = (rootReducer) => (state, action) => {
    if (action.type === 'SIGN_OUT') {
        return rootReducer(undefined, action);
    }

    return rootReducer(state, action);
};

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['language', 'manager', 'menu', 'ShopNotification', 'billing', 'callNotification', 'clientStatusList'],
};

const persistedReducer = persistReducer(persistConfig, resetEnhancer(reducers));

const saga = createSagaMiddleware();

//redux dev tool
const composeEnhancers = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;
const enhancer = composeEnhancers(applyMiddleware(saga));

// const store = createStore(reducers, enhancer);
const store = createStore(persistedReducer, enhancer);

export const persistor = persistStore(store);

saga.run(watchSagas);

export default store;
